import { type ReactNode } from 'react';

import { useSharepointWorkbookGraph } from '../hooks/useSharepointWorkbookGraph';
import { SharepointLoadBuildingGraphContext } from './context';

type SharepointWorkbookGraphProviderProps = {
  enabled: boolean;
  children: ReactNode;
};

/**
 * Turvo: backend-produced suggestions from `POST /sharepoint/workbooks/load-suggestions`.
 *
 * McLeod / Syfan Agile uses {@link SharepointEwaAgileRowsProvider} instead (EWA → service worker).
 */
export function SharepointWorkbookGraphProvider({
  enabled,
  children,
}: SharepointWorkbookGraphProviderProps) {
  const value = useSharepointWorkbookGraph({ enabled });

  return (
    <SharepointLoadBuildingGraphContext.Provider value={value}>
      {children}
    </SharepointLoadBuildingGraphContext.Provider>
  );
}
